/**
 * Module dependencies.
 */

import { apiEndpoints } from 'app/core/config/api-endpoints';
import { appRoutes } from 'app/routes';
import { CrudListType, CrudRemoveType, CrudTemplate, ListColumns } from '../../../organisms/crud/form-types';
import { ListFilters } from 'app/components/organisms/crud/form-filters/form-filters-type';
import { TFunction } from 'react-i18next';
import React from 'react';
import { DateTime } from 'app/components/atoms/date-time/date-time';
import { Modal } from 'antd';
import { TherapySyncLogDetail } from './therapy-sync-log-detail';

/**
 * List labels.
 */

const listColumns = (translate: TFunction): ListColumns<any> => [
  {
    title: translate('common.table.columns.id'),
    dataIndex: 'id',
    key: 'id',
    size: '1fr'
  },
  {
    title: translate('common.table.columns.hasError'),
    dataIndex: 'error',
    key: 'error',
    render: item => (!item.error ? 'NO' : <div style={{ color: 'red' }}>{'YES'}</div>)
  },
  {
    title: translate('common.table.columns.statusCode'),
    dataIndex: 'responseStatus',
    key: 'responseStatus'
  },
  {
    title: translate('common.table.columns.createdAt'),
    dataIndex: 'createdAt',
    key: 'createdAt',
    render: item => <DateTime date={item.createdAt} />
  },
  {
    title: translate('common.table.columns.updatedAt'),
    dataIndex: 'updatedAt',
    key: 'updatedAt',
    render: item => <DateTime date={item.updatedAt} />
  }
];

/**
 * List filters.
 */

const listFilters = (translate: TFunction): ListFilters => [
  {
    type: 'inputSearch',
    inline: true,
    name: 'search',
    label: translate('common.labels.search')
  },
  {
    type: 'selectSearch',
    name: 'accessType',
    inline: true,
    label: translate('common.labels.accessType'),
    showSearch: true,
    allowClear: true,
    options: [
      {
        label: translate('common.labels.user'),
        value: 'user'
      },
      {
        label: translate('common.labels.backOffice'),
        value: 'backOffice'
      },
      {
        label: translate('common.labels.admin'),
        value: 'admin'
      }
    ]
  }
];

/**
 * List.
 */

function list(translate: TFunction): CrudListType<any> {
  return {
    columns: listColumns(translate),
    filters: listFilters(translate),
    route: appRoutes.dashboard.users.detail.devTools,
    enableExport: true,
    addButton: translate('common.actions.add'),
    canEdit: false,
    canRemove: true,
    clickLine: (item: any) => {
      Modal.confirm({
        title: 'Therapy Sync Info',
        content: <TherapySyncLogDetail item={item} />,
        cancelButtonProps: { style: { display: 'none' } },
        onOk() {
          console.log('Compra confirmada!');
        },
        width: 800
      });
    },
    resolveParams: (params: any, item?: any) => {
      return {
        userId: params.userId,
        deviceId: params.id ?? item?.deviceId
      };
    },
    key: ['therapySyncLogs'],
    pagination: {
      pageSize: 25,
      pageSizeOptions: [10, 25, 50, 100, 500, 1000]
    },
    endpoint: apiEndpoints.userDevTherapySyncLogs,
    endpointById: apiEndpoints.userDevTherapySyncLogsById
  };
}

/**
 * Remove.
 */

const remove = (): CrudRemoveType<any> => ({
  resolveParams: (params: any, item?: any) => {
    return {
      userId: params.userId,
      id: params.id ?? item?.id
    };
  },
  endpoint: apiEndpoints.userDevTherapySyncLogsById
});

/**
 * Config.
 */

export function createUserAlarmsSyncConfig(translate: TFunction): CrudTemplate<any> {
  return {
    list: list(translate),
    remove: remove()
  };
}
